<template>
  <div class="topNav">
    <div class="content warp">
      <div class="indexPage">
        <div>欢迎来到中国幼教网商城！</div>

        <div v-if="!isLogin">
          <a @click="loginBtn">请登录</a>

          <a @click="register">免费注册</a>
        </div>
        <div v-if="isLogin" ><a @click="goToUserInfo">{{userInfoData.name}}</a></div>

        <div v-if="isLogin" ><a @click="outLoginBtn">退出登录</a></div>

        <!-- 我的 -->
        <div v-if="false" class="item item-select">
          <span class="hover-item"><i class="iconfont icon-user"></i>我的<i class="ico-arrow el-icon-arrow-down"></i></span>
          <div class="cart-box user-box">
            <div class="info">
              <div class="avatar" @click="goToUserInfo">
                <img :src="userInfoData.headImage">
              </div>
              <div class="vip">
                <div class="top">
                  <div class="level">{{ userInfoData.memberLevelName}} </div>
                  <div class="logout" @click="outLoginBtn">退出登录</div>
                </div>
                <div class="bottom">
                  <p>会员成长值：<span>{{ userInfoData.growth }}/{{ userInfoData.nextLevelGrowth }}</span></p>
                  <el-progress
                    :show-text="false"
                    :percentage="parseInt(userInfoData.growth / userInfoData.nextLevelGrowth) * 100 || 0">
                  </el-progress>
                </div>
              </div>
            </div>
            <ul class="personal">
              <li @click="goToUserAddress">
                <icon-svg
                  style="font-size: 54px;"
                  icon-class="nav-addres"
                />
                收货地址
              </li>
              <li @click="gotoUserCoupon">
                <icon-svg
                  style="font-size: 54px;"
                  icon-class="nav-coupon"
                />
                券包
              </li>
              <li @click="goToAfterOrder">
                <icon-svg
                  style="font-size: 54px;"
                  icon-class="nav-aftersale"
                />
                售后订单
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="right">
        <!--        <div class="item" @click="applySettle">-->
        <!--          <a class="hover-item" >申请入驻</a>-->
        <!--        </div>-->
        <div class="item" @click="yjHome">
          <a class="hover-item" >中国幼教网首页</a>
        </div>
        <div class="item" @click="goToUserInfo">
          <a class="hover-item" >会员中心</a>
        </div>
        <div class="item" @click="goToShopCart">
          <a class="hover-item" ><i class="el-icon-shopping-cart-2" style="color: #7b7afa"></i> 购物车</a>
        </div>

        <div class="item item-select">
          <span class="hover-item">我的订单<i class="ico-arrow el-icon-arrow-down"></i></span>
          <div class="cart-box order-box">
            <ul class="personal">
              <li>
                <router-link to="/myOrder">
                  未确认订单
                </router-link>
              </li>
              <li>
                <router-link to="/myOrder2">
                  已确认订单
                </router-link>
              </li>
            </ul>
          </div>
        </div>

<!--        <div class="item">-->
<!--          <a class="hover-item" >会员商家</a>-->
<!--        </div>-->

<!--        <div class="item">-->
<!--          <a class="hover-item" >网站导航</a>-->
<!--        </div>-->
        <div class="item" @click="suggest">
          <a class="hover-item" >意见反馈</a>
        </div>
      </div>
    </div>
    <suggest ref="suggest"></suggest>
  </div>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex'
import Cookie from 'js-cookie'
import { Encrypt } from '@/util/secret'
import Suggest from '@/components/base/suggest.vue'
import {
  getUserInfo, autoLogin
} from '@/api/user/user.js'
import {
  getGongGaoAll
} from '@/api/user/notice.js'
import {
  getCartList,
  deleteCartItem
} from '@/api/user/cart.js'
import {
  settled
} from '@/api/nav.js'
import {
  getCheckState
} from '@/api/user/enterpriseCertification.js'
import store from '@/store/index.js'

export default {
  name: 'siteNav',
  components: {Suggest},
  props: {
    componentContent: {
      type: Object
    }
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'shoppingCart',
      'cartNumber'
    ])
  },
  data () {
    return {
      userInfoData: '',
      searchVal: '宝贝',
      keyword: '',
      isShowOut: false,
      menuOpen: false,
      isLogin: false,
      isShowNum: false,
      deleteOpt: {
        visiable: false
      },
      proList: [],
      noticeList: [],
      form: {
        enterpriseName: "",
        enterpriseCode: "",
      }
    }
  },
  watch: {
    '$store.state.isLogin': {
      handler (nVal, oVal) {
        this.isLogin = nVal
        this.isShowNum = nVal
        if (this.isLogin) {
          this.getUserInfoData()
          this.getTrolleyList()
        }
      }
    }
  },
  created (e) {
    if(this.$route.query.sessionId){
      if(!Cookie.get('token')){
        autoLogin({sessionId: this.$route.query.sessionId}).then(res => {
          let data = res.data.data;

          if(data){
            Cookie.set('token', data.token, { expires: 1 })
            store.commit('SET_USERINFO', data)
            store.commit('IS_LOGIN', true)

            this.isLogin = true
            this.isShowNum = true
            this.getTrolleyList()
            this.getGongGao()
            this.getUserInfoData()
            this.getEnterpriseCheckState()
          }
        })
      }else{
        this.isLogin = true
        this.isShowNum = true
        this.getTrolleyList()
        this.getGongGao()
        this.getUserInfoData()
        this.getEnterpriseCheckState()
      }
    }else{
      if (Cookie.get('token')) {
        this.isLogin = true
        this.isShowNum = true
        this.getTrolleyList()
        this.getGongGao()
        this.getUserInfoData()
        this.getEnterpriseCheckState()
      }
    }
  },
  methods: {
    ...mapMutations({
      setSearchObj: 'SET_SEARCHOBJ',
      setUserInfo: 'SET_USERINFO',
      setCartNumber: 'SET_CARTNUMBER',
      setShoppingCart: 'SET_SHOPPINGCART',
      setNewAddress: 'SET_NEWADDRESS',
      setAreaCode: 'SET_AREACODE',
      setNoticeId: 'SET_NOTICEID',
      IS_LOGIN: 'IS_LOGIN'
    }),
    searchCommand (command) {
      this.searchVal = command
    },
    // 个人信息
    async getUserInfoData () {
      const response = await getUserInfo()
      const res = response.data
      if (res.code === '200') {
        this.setUserInfo(res.data)
        this.userInfoData = res.data
      } else {
        this.$message.error('获取个人信息失败！')
      }
    },
    // 购物车列表
    async getTrolleyList () {
      const response = await getCartList()
      const res = response.data
      let cartNumber = 0
      if (res.data && res.data.length) {
        res.data.forEach(j => {
          cartNumber = cartNumber + j.skus.length
        })
      }
      this.setShoppingCart(res.data)
      this.setCartNumber(cartNumber)
    },
    // 公告
    async getGongGao () {
      const response = await getGongGaoAll()
      const res = response.data
      if (res.code === '200') {
        this.noticeList = res.data
      } else {
        this.$message.warning(res.message)
      }
    },
    // 删除单个商品
    async deleteCartItem (item) {
      let ids = []
      ids.push(item.skuId)
      await deleteCartItem({ ids })
      let id = item.skuId
      this.shoppingCart.map(j => {
        j.skus.map(k => {
          if (k.skuId === id) {
            j.skus.splice(j.skus.findIndex(item => item.skuId === id), 1)
          }
        })
      })
      this.setCartNumber(this.cartNumber - 1)
      this.getTrolleyList()
      this.$message.success('删除成功')
    },
    outLoginBtn () {
      this.$confirm("确定退出登录吗？")
        .then((_) => {
          Cookie.remove('token')
          this.setUserInfo({})
          this.setCartNumber('')
          this.setShoppingCart({})
          this.setNewAddress({})
          this.setAreaCode([])
          // this.$router.push({path: '/login', query: {type: 2}})
          this.$store.commit('IS_LOGIN', false) // 清除登录状态
          this.isLogin = false
          this.isShowNum = false

          this.$router.push({path: '/index'})
        })
        .catch((_) => {});
    },
    // 申请入驻
    applySettle () {
      let token
      if (Cookie.get('token')) {
        token = Encrypt(Cookie.get('token'))
      } else {
        this.$router.push({path: '/login'})
        return
      }
      let username = encodeURI(this.userInfo.name)
      let userInfo = encodeURI(username)
      // let test = Decrypt(token)
      window.open(`${settled}?username=${userInfo}&user=${token}`)
    },

    yjHome(){
      window.open('https://www.chinayoujiao.com/index/index.html?token=' + (Cookie.get('token') || ''))
    },
    goToUserInfo () {
      if (Cookie.get('token')) {
        this.$router.push({path: '/userInfo'})
      } else {
        this.$router.push({path: '/login?rtn=' + encodeURIComponent('/userInfo')})
      }
    },
    goToUserOrder () {
      if (Cookie.get('token')) {
        this.$router.push({path: '/myOrder'})
      } else {
        this.$router.push({path: '/login?rtn=' + encodeURIComponent('/myOrder')})
      }
    },
    goToAfterOrder () {
      if (Cookie.get('token')) {
        this.$router.push({path: '/orderAfterSale'})
      } else {
        this.$router.push({path: '/login?rtn=' + encodeURIComponent('/orderAfterSale')})
      }
    },
    loginBtn () {
      this.$router.push({path: '/login'})
    },
    goToUserAddress () {
      if (Cookie.get('token')) {
        this.$router.push({path: '/signingAddress'})
      } else {
        this.$router.push({path: '/login?rtn=' + encodeURIComponent('/signingAddress')})
      }
    },
    gotoUserCoupon () {
      if (Cookie.get('token')) {
        this.$router.push({path: '/couponPackage'})
      } else {
        this.$router.push({path: '/login?rtn=' + encodeURIComponent('/couponPackage')})
      }
    },
    goToShopCart () {
      if (Cookie.get('token')) {
        this.$router.push({path: '/shopping-trolley'})
      } else {
        this.$router.push({path: '/login?rtn=' + encodeURIComponent('/shopping-trolley')})
      }
    },
    hover () {
      this.isShowOut = true
    },
    register(){
      this.$router.push({
        path: '/register'
      })
    },
    // 跳转到公告详情
    goToDetail (id) {
      this.$router.push({
        path: '/activity/notificationDetails',
        query: {
          id: id
        }
      })
      this.setNoticeId(id)
    },
    //获取企业认证信息
    async getEnterpriseCheckState() {
      const response = await getCheckState();
      if (response.status == 200) {
        this.form = response.data.data;
      }
      console.log(this.form);
    },
    suggest(){
      this.$refs.suggest.show();
    }
  }
}
</script>

<style lang="scss" scoped>
$lightBlack: #666666;
$navSearchHeight: 39px;
.topNav{
  width: 100%;
  height: 30px;
  line-height: 30px;
  background: #fafafa;
  border-bottom: #efefef solid 1px;
  .content{
    width: 1200px;
    height: 30px;
    margin: 0 auto;
    font-size: 14px;
    color: #6a6a6a;
    .search{
      width: 430px;
      max-width: 100%;
      height: $navSearchHeight;
      margin: 5px;
      border: 1px solid $lightBlack;
      border-radius: 0px;
      overflow: hidden;
      position: relative;
      display: flex;
      .searchSelect{
        margin: 10px 10px 10px 0;
        padding: 0 12px;
        border-right: 1px  solid #E5E5E5;
        >>> .el-dropdown-link{
          font-size: 16px;
          color: #fff;
        }
      }
      .searchRight{
        flex: 1;
        input{
          width: 100%;
          height: $navSearchHeight;
          color: #CCCCCC;
          padding: 0 60px 0 15px;
          font-size: 14px;
          box-sizing: border-box;
          background-color: $lightBlack;
        }
      }
      .btn{
        width: 25px;
        height: 100%;
        padding-right: 12px;
        background-color: $lightBlack;
        color: #fff;
        line-height: $navSearchHeight;
        text-align: center;
        cursor: pointer;
      }
    }
    .indexPage{
      div{
        float: left;
        margin-right: 10px;
      }
      a{
        padding: 0 5px;
      }
    }
    .item{
      padding: 0 15px;
      display: inline-block;
      span{
        cursor: pointer;
        b{
          color: $mainGlod;
          padding: 0 2px;
        }
      }
      .iconfont{
        margin-right: 5px;
      }
      .icon-user{
        font-size: 14px;
      }
      &.item-select{
        padding-right: 33px;
        position: relative;
        .ico-arrow{
          position: relative;
          position: absolute;
          right: 15px;
          top: 7px;
          margin-right: 0;
        }
      }
      &:hover{
        background-color: #fff;
        .cart-no-data,.cart-no-login{
          display: flex;
        }
        .cart-list,.user-box,.order-box{
          display: block;
        }
        .hover-item{
          color: $mainGlod;
        }
      }
    }

    .right{
      float: right;
      margin-right: -15px;
    }
    .cart-box{
      position: absolute;
      top: 30px;
      background-color: #fff;
      z-index: 999;
      border-radius: 5px;
      box-shadow: 0px 0px 24px 3px rgba(0, 0, 0, 0.06);
      .cartImgBox {
        img {
          width: 100%;
        }
      }
      &.cart-no-login{
        min-width: 200px;
        left: -100px;
        height: 160px;
        display: none;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .btn{
          display: inline-block;
          padding: 0 15px;
          height: 26px;
          line-height: 26px;
          text-align: center;
          color: #fff;
          background-color: $mainColor;
          border-radius: 4px;
          margin-bottom: 40px;
        }
        .p{
          color: #666666;
          line-height: 1em;
        }
      }
      &.cart-no-data{
        width: 264px;
        height: 110px;
        left: 50%;
        margin-left: -132px;
        display: none;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: #666;
      }
      &.cart-list{
        width: 348px;
        left: 50%;
        margin-left: -174px;
        display: none;
        padding: 10px;
        .cartItem{
          border-bottom: 1px solid #F5F5F5;
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        dl{
          flex: 1;
          width: 100%;
          height: 70px;
          margin: 5px 0;
          dt{
            float: left;
            cursor: pointer;
          }
          dd{
            margin-left: 54px;
            position: relative;
            padding-right: 60px;
            min-height: 42px;
            line-height: 21px;
            h4{
              color: #333;
              cursor: pointer;
              font-size: 14px;
              @include ellipsis;
            }
            p{
              color: #333;
              font-size: 14px;
              @include ellipsis;
            }
            span{
              color: #C83732;
              position: absolute;
              top: 0;
              right: 0;
              font-size: 14px;
            }
            .btn-del{
              color: #333;
              position: absolute;
              top: 20px;
              right: 0;
              font-size: 14px;
            }
          }
        }
        .btn-view-all{
          display: block;
          margin: auto;
          // float: right;
          padding: 0 15px;
          height: 26px;
          line-height: 26px;
          text-align: center;
          color: #fff;
          background-color: $mainGlod;
          border-radius: 4px;
          margin-top: 10px;
          cursor: pointer;
        }
      }
      &.user-box{
        width: 400px;
        top: 40px;
        left: -315px;
        // padding: 18px 0;
        display: none;
        .info{
          display: flex;
          margin: 15px;
          height: 60px;
          .avatar{
            background-color: #666666;
            cursor: pointer;
            img{
              width: 54px;
              height: 54px;
            }
          }
          .vip{
            margin-left: 10px;
            flex: 1;
            cursor: default;
            .top{
              width: 100%;
              height: 35px;
              display: flex;
              justify-content: space-between !important;
              align-items: center;
              .level{
                display: block;
                width: 86px;
                height: 22px;
                color: $mainGlod;
                position: relative;
                top: -15px;
              }
              .logout{
                width: 115px;
                height: 30px;
                line-height: 30px;
                text-align: center;
                font-size: 14px;
                font-family: Microsoft YaHei;
                box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.16);
                border-radius: 3px;
                cursor: pointer;
              }
            }
            .bottom{
              p{
                font-size: 12px;
                line-height: 16px;
                color: #999999;
                span{
                  color: $mainGlod;
                }
              }
            }
          }
        }
        .personal{
          display: flex;
          justify-content: space-around;
          clear: both;
          li{
            flex: 1;
            font-size: 16px;
            padding-top: 12px;
            cursor: pointer;
            color: #333;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            &:hover{
              color: $mainGlod;
              background-color: #F5F5F5;
            }
          }
        }
      }

      &.order-box{
        width: 100%;
        left: 0;
        display: none;
        .personal{
          font-size: 14px;
          text-align: center;
          li{
            cursor: pointer;
            &:hover{
              color: $mainGlod;
              background-color: #fafafa;
            }
          }
        }
      }
    }
  }
  .loginBtn{
    width: 115px;
    margin: 15px auto;
    line-height: 30px;
    text-align: center;
    color: $mainGlod;
    border: 1px solid #333333;
    cursor: pointer;
    &:hover{
      background: #FFFFFF;
      border-color: $mainGlod;
    }
  }
  .checkOut{
    color: #FFF;
    background-color: #333;
    &:hover{
      background-color: $mainGlod;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/base/topNav.vue